import { render, staticRenderFns } from "./New.vue?vue&type=template&id=49315219&"
import script from "./New.vue?vue&type=script&setup=true&lang=js&"
export * from "./New.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports